export default "__VITE_ASSET__CRzEaiSb__"